import { render, staticRenderFns } from "./pioneer6-accessories.vue?vue&type=template&id=0b711db0&scoped=true"
import script from "./pioneer6-accessories.vue?vue&type=script&lang=js"
export * from "./pioneer6-accessories.vue?vue&type=script&lang=js"
import style0 from "./pioneer6-accessories.vue?vue&type=style&index=0&id=0b711db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b711db0",
  null
  
)

export default component.exports